import logo from "../images/logo_placeholder.png"
import loginIcon from "../images/loginIcon.jpg"
import signupLogo from "../images/signupIcon.png"
import featureIcon from "../images/featureIcon_placeholder.png"

const theme = {
  baseFontSize: "1.5rem",
  firstColor: "forestgreen",
  secondColor: "#4f4f4f",
  thirdColor: "gold",
  fourthColor: '#f4f4f4',
  mainLogo: logo,
  loginLogo: loginIcon,
  signupLogo: signupLogo,
  featureLogo: featureIcon
};

export default theme;
